import shallow from "zustand/shallow";
import { useStoreSystem } from "../store";

export const useCameraCustom = () => {
    const { moveCameraEnabled, isMoveCamera, setMoveCameraEnabled, setIsMoveCamera } = useStoreSystem((state) => ({
        moveCameraEnabled: state.moveCameraEnabled,
        isMoveCamera: state.isMoveCamera,
        setMoveCameraEnabled: state.setMoveCameraEnabled,
        setIsMoveCamera: state.setIsMoveCamera,
    }), shallow);

    return {
        isMoveCamera,
        setIsMoveCamera,
        moveCameraEnabled,
        setMoveCameraEnabled,
    };
};
